import PropTypes from 'prop-types';
import React from 'react';

const Spacer = ({
  as: Component = 'div',
  height,
  width,
  additionalStyles,
  ...props
}) => (
  <Component
    {...props}
    style={{
      height: `${height}px`,
      minHeight: `${height}px`,
      width: `${width}px`,
      minWidth: `${width}px`,
      ...additionalStyles,
    }}
  />
);

Spacer.propTypes = {
  additionalStyles: PropTypes.shape({ [PropTypes.string]: PropTypes.string }),
  as: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Spacer.defaultProps = {
  additionalStyles: undefined,
  as: 'div',
  height: 20,
  width: 0,
};

Spacer.displayName = 'Spacer';

export default Spacer;
